import React, { useState, useEffect } from 'react';
import './BodyParts.css';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// Image imports for body parts
import Forefist from './images/forefist.webp';
import Knifehand from './images/knifehand.webp';
import Palm from './images/palm.webp';
import Fingertips from './images/fingertips.webp';
import Backfist from './images/backfist.webp';
import Sidefist from './images/sidefist.webp';
import Reverse_Knifehand from './images/reverseknifehand.webp';
import Elbow from './images/elbow.webp';
import Outer_Forearm from './images/outerforearm.webp';
import Inner_Forearm from './images/innerforearm.webp';
import Ball_of_Foot from './images/balloffoot.webp';
import Toes from './images/toes.webp';
import Heel from './images/heel.webp';
import Footsword from './images/footsword.webp';
import Instep from './images/instep.webp';
import Knee from './images/knee.webp';
import Levels from './images/levels.webp';
// Vital images
import ArcHandVital from './images/archand_vital.webp';
import BackHeelVital from './images/backheel_vital.webp';
import BackFistVital from './images/backfist_vital.webp';
import BackHandVital from './images/backhand_vital.webp';
import BallOfTheFootVital from './images/ballofthefoot_vital.webp';
import BaseOfKnifehandVital from './images/baseofknifehand_vital.webp';
import BearHandVital from './images/bearhand_vital.webp';
import ElbowVital from './images/elbow_vital.webp';
import FingerPincersVital from './images/fingerpincers_vital.webp';
import FingerPressVital from './images/fingerpress_vital.webp';
import FingerTipsVital from './images/fingertip_vital.webp';
import FootSwordVital from './images/footsword_vital.webp';
import ForefistVital from './images/forefist_vital.webp';
import ForeheadVital from './images/forehead_vital.webp';
import InstepVital from './images/instep_vital.webp';
import KneeVital from './images/knee_vital.webp';
import KnifehandVital from './images/knifehand_vital.webp';
import KnuckleFistVital from './images/knucklefist_vital.webp';
import LongFistVital from './images/longfist_vital.webp';
import OcciputVital from './images/occiput_vital.webp';
import OpenFistVital from './images/openfist_vital.webp';
import ReverseFootSwordVital from './images/reversefootsword_vital.webp';
import ReverseKnifehandVital from './images/reverseknifehand_vital.webp';
import SideFistVital from './images/sidefist_vital.webp';
import SoleOfTheFootVital from './images/soleofthefootagainstfallenopponent_vital.webp';
import ToesWithShoesVital from './images/toeswithshoes_vital.webp';
import UnderFistVital from './images/underfist_vital.webp';

import branchesData from './branches.json';
import invertedbranchesData from './branches_inverted.json';

// Body parts array
const bodyParts = [
  { label: 'Forefist', korean: 'Ap Joomuk', image: Forefist },
  { label: 'Knifehand', korean: 'Sonkal', image: Knifehand },
  { label: 'Palm', korean: 'Sonbadok', image: Palm },
  { label: 'Fingertips', korean: 'Sunkut', image: Fingertips },
  { label: 'Backfist', korean: 'Dung Joomuk', image: Backfist },
  { label: 'Sidefist', korean: 'Yop Joomuk', image: Sidefist },
  { label: 'Reverse Knifehand', korean: 'Sonkal Dung', image: Reverse_Knifehand },
  { label: 'Elbow', korean: 'Palkup', image: Elbow },
  { label: 'Outer Forearm', korean: 'Bakat Palmok', image: Outer_Forearm },
  { label: 'Inner Forearm', korean: 'An Palmok', image: Inner_Forearm },
  { label: 'Ball of Foot', korean: 'Ap Kumchi', image: Ball_of_Foot },
  { label: 'Toes', korean: 'Balkut', image: Toes },
  { label: 'Heel', korean: 'Dwitchook', image: Heel },
  { label: 'Footsword', korean: 'Balkal', image: Footsword },
  { label: 'Instep', korean: 'Baldung', image: Instep },
  { label: 'Knee', korean: 'Moorup', image: Knee },
];

// Vital points data
const vitalPoints = [
  {
    label: "Arc Hand",
    description: "<b>1:</b> Upper neck<br><b>2:</b> Adam's Apple<br><b>3:</b> Point of the chin",
    image: ArcHandVital
  },
  {
    label: "Back Heel",
    description: "<b>1:</b> Chest<br><b>2:</b> Skull<br><b>3:</b> Temple<br><b>4:</b> Heart<br><b>5:</b> Liver/Floating Ribs<br><b>6:</b> Spleen/Floating Ribs<br><b>7:</b> Sternum<br><b>8:</b> Philtrum<br><b>9:</b> Solar Plexus/Epigastrium<br><b>10:</b> Lower Abdomen<br><b>11:</b> Achilles' Tendon",
    image: BackHeelVital
  },
  {
    label: "Back Fist",
    description: "<b>1:</b> Skull<br><b>2:</b> Temple<br><b>3:</b> Philtrum<br><b>4:</b> Forehead<br><b>5:</b> Floating Ribs<br><b>6:</b> Epigastrium<br><b>7:</b> Lower Abdomen<br><b>8:</b> Occiput",
    image: BackFistVital
  },
  {
    label: "Back Hand",
    description: "<b>1:</b> Epigastrium<br><b>2:</b> Jaw<br><b>3:</b> Lips",
    image: BackHandVital
  },
  {
    label: "Ball of the Foot",
    description: "<b>1:</b> Groin<br><b>2:</b> Bridge of the Nose<br><b>3:</b> Lower Abdomen<br><b>4:</b> Solar Plexus<br><b>5:</b> Epigastrium<br><b>6:</b> Inner Thigh<br><b>7:</b> Scrotum<br><b>8:</b> Face<br><b>9:</b> Sternum<br><b>10:</b> Philtrum<br><b>11:</b> Heart<br><b>12:</b> Spleen/Floating Ribs<br><b>13:</b> Liver/Floating Ribs<br><b>14:</b> Temple<br><b>15:</b> Coccyx",
    image: BallOfTheFootVital
  },
  {
    label: "Base of Knifehand",
    description: "<b>1:</b> Clavicle",
    image: BaseOfKnifehandVital
  },
  {
    label: "Bear Hand",
    description: "<b>1:</b> Mastoid<br><b>2:</b> Solar Plexus<br><b>3:</b> Epigastrium",
    image: BearHandVital
  },
  {
    label: "Elbow",
    description: "<b>1:</b> Upper Neck<br><b>2:</b> Small of the Back<br><b>3:</b> Kidney<br><b>4:</b> Epigastrium<br><b>5:</b> Liver/Floating Ribs<br><b>6:</b> Public Region<br><b>7:</b> Spleen/Floating Ribs<br><b>8:</b> Sternum<br><b>9:</b> Heart<br><b>10:</b> Point of the Chin<br><b>11:</b> Jaw<br><b>12:</b> Solar Plexus",
    image: ElbowVital
  },
  {
    label: "Finger Pincers",
    description: "<b>1:</b> Adam's Apple",
    image: FingerPincersVital
  },
  {
    label: "Finger Press",
    description: "<b>1:</b> Point of the Chin<br><b>2:</b> Back-wrist Artery<br><b>3:</b> Under-wrist Artery<br><b>4:</b> Armpit<br><b>5:</b> Achilles' Tendon<br><b>6:</b> Mastoid<br><b>7:</b> Thenar",
    image: FingerPressVital
  },
  {
    label: "Finger Tips",
    description: "<b>1:</b> Armpit<br><b>2:</b> Umbilicus<br><b>3:</b> Eyeball<br><b>4:</b> Windpipe<br><b>5:</b> Mastoid<br><b>6:</b> Floating Ribs<br><b>7:</b> Pubic Region<br><b>8:</b> Solar Plexus",
    image: FingerTipsVital
  },
  {
    label: "Foot Sword",
    description: "<b>1:</b> Bridge of the Nose<br><b>2:</b> Tibia<br><b>3:</b> Armpit<br><b>4:</b> Philtrum<br><b>5:</b> Heart<br><b>6:</b> Floating Ribs<br><b>7:</b> Liver/Floating Ribs<br><b>8:</b> Solar Plexus<br><b>9:</b> Neck Artery<br><b>10:</b> Knee Joint<br><b>11:</b> Ankle Joint<br><b>12:</b> Upper Neck<br><b>13:</b> Temple<br><b>14:</b> Face",
    image: FootSwordVital
  },
  {
    label: "Forefist",
    description: "<b>1:</b> Philtrum<br><b>2:</b> Sternum<br><b>3:</b> Solar Plexus/Epigastrium<br><b>4:</b> Jaw<br><b>5:</b> Point of the Chin<br><b>6:</b> Mandibular Joint<br><b>7:</b> Heart<br><b>8:</b> Spleen/Floating Ribs<br><b>9:</b> Liver/Floating Ribs<br><b>10:</b> Lower Abdomen",
    image: ForefistVital
  },
  {
    label: "Forehead",
    description: "<b>1:</b> Nose<br><b>2:</b> Bridge of the Nose<br><b>3:</b> Philtrum<br><b>4:</b> Forehead<br><b>5:</b> Heart",
    image: ForeheadVital
  },
  {
    label: "Instep",
    description: "<b>1:</b> Philtrum<br><b>2:</b> Solar Plexus<br><b>3:</b> Scrotum<br><b>4:</b> Lower Abdomen<br><b>5:</b> Floating Ribs<br><b>6:</b> Jaw<br><b>7:</b> Face",
    image: InstepVital
  },
  {
    label: "Knee",
    description: "<b>1:</b> Philtrum<br><b>2:</b> Solar Plexus/Epigastrium<br><b>3:</b> Scrotum<br><b>4:</b> Lower Abdomen<br><b>5:</b> Coccyx",
    image: KneeVital
  },
  {
    label: "Knifehand",
    description: "<b>1:</b> Skull<br><b>2:</b> Temple<br><b>3:</b> Bridge of the Nose<br><b>4:</b> Philtrum<br><b>5:</b> Angle of Mandible<br><b>6:</b> Adam's Apple<br><b>7:</b> Cervix<br><b>8:</b> Floating Ribs<br><b>9:</b> Neck Artery<br><b>10:</b> Shoulder Joint",
    image: KnifehandVital
  },
  {
    label: "Knuckle Fist",
    description: "<b>1:</b> Temple<br><b>2:</b> Bridge of the Nose<br><b>3:</b> Philtrum<br><b>4:</b> Adam's Apple<br><b>5:</b> Solar Plexus",
    image: KnuckleFistVital
  },
  {
    label: "Long Fist",
    description: "<b>1:</b> Temple<br><b>2:</b> Solar Plexus<br><b>3:</b> Adam's Apple",
    image: LongFistVital
  },
  {
    label: "Occiput",
    description: "<b>1:</b> Nose<br><b>2:</b> Lips",
    image: OcciputVital
  },
  {
    label: "Open Fist",
    description: "<b>1:</b> Abdomen<br><b>2:</b> Jaw<br><b>3:</b> Point of the Chin<br><b>4:</b> Nose",
    image: OpenFistVital
  },
  {
    label: "Reverse Foot Sword",
    description: "<b>1:</b> Solar Plexus<br><b>2:</b> Face",
    image: ReverseFootSwordVital
  },
  {
    label: "Reverse Knifehand",
    description: "<b>1:</b> Temple<br><b>2:</b> Philtrum<br><b>3:</b> Angle of Mandible<br><b>4:</b> Adam's Apple<br><b>5:</b> Floating Ribs<br><b>6:</b> Point of the Chin<br><b>7:</b> Neck Artery",
    image: ReverseKnifehandVital
  },
  {
    label: "Side Fist",
    description: "<b>1:</b> Skull<br><b>2:</b> Floating Ribs<br><b>3:</b> Epigastrium/Solar Plexus<br><b>4:</b> Lower Abdomen<br><b>5:</b> Occiput<br><b>6:</b> Shoulder Joint<br><b>7:</b> Elbow Joint<br><b>8:</b> Philtrum",
    image: SideFistVital
  },
  {
    label: "Sole of the Foot (Against fallen opponent)",
    description: "<b>1:</b> Lower Abdomen<br><b>2:</b> Heart<br><b>3:</b> Spleen/Floating Ribs<br><b>4:</b> Liver/Floating Ribs<br><b>5:</b> Adam's Apple<br><b>6:</b> Instep<br><b>7:</b> Solar Plexus/Epigastrium<br><b>8:</b> Sternum<br><b>9:</b> Philtrum",
    image: SoleOfTheFootVital
  },
  {
    label: "Toes (With shoes)",
    description: "<b>1:</b> Epigastrium<br><b>2:</b> Sternum<br><b>3:</b> Temple<br><b>4:</b> Philtrum<br><b>5:</b> Floating Ribs<br><b>6:</b> Windpipe<br><b>7:</b> Bridge of the Nose<br><b>8:</b> Scrotum<br><b>9:</b> Inner Thigh<br><b>10:</b> Point of the Chin",
    image: ToesWithShoesVital
  },
  {
    label: "Under Fist",
    description: "<b>1:</b> Philtrum<br><b>2:</b> Temple<br><b>3:</b> Solar Plexus<br><b>4:</b> Lips<br><b>5:</b> Jaw<br><b>6:</b> Adam's Apple",
    image: UnderFistVital
  }
];

// Section component
const Section = ({ title, koreanTitle, children }) => (
  <section>
    <h2>{title} <span className="korean">{koreanTitle}</span></h2>
    {children}
  </section>
);

// VitalPointsSpinner component
const VitalPointsSpinner = () => {
  const [selectedVital, setSelectedVital] = useState(vitalPoints[0]);
  const handleChange = (e) => {
    const selectedLabel = e.target.value;
    const selected = vitalPoints.find(vp => vp.label === selectedLabel);
    setSelectedVital(selected);
  };
  return (
    <div className="vital-spinner-container">
      <h3>Vital Points</h3>
      <select onChange={handleChange} value={selectedVital.label}>
        {vitalPoints.map((vp, index) => (
          <option key={index} value={vp.label}>
            {vp.label}
          </option>
        ))}
      </select>
      <img className="vital-image" src={selectedVital.image} alt={selectedVital.label} />
      <div className="vital-description" dangerouslySetInnerHTML={{ __html: selectedVital.description }} />
    </div>
  );
};

const CascadingSpinners = () => {
  const [spinnerData, setSpinnerData] = useState([[], [], [], [], []]);
  const [selectedPath, setSelectedPath] = useState(['', '', '', '', '']);
  const [isInverted, setIsInverted] = useState(false);
  const [isOneStep, setIsOneStep] = useState(false);
  const [root, setRoot] = useState(null);

  const spinnerLabels = isInverted
    ? ["Attacking Tool", "Attacking Method", "Part Blocked", "Direction", "Blocking Tool"]
    : ["Blocking Tool", "Direction", "Part Blocked", "Attacking Method", "Attacking Tool"];

  // Load JSON data
  useEffect(() => {
    loadBranchJSON(isInverted);
  }, [isInverted]);

  const loadBranchJSON = (inverted) => {
    const data = inverted ? invertedbranchesData : branchesData;
    setRoot(data);
    const rootKeys = Object.keys(data).sort();
    setSpinnerData([rootKeys, [], [], [], []]);
    setSelectedPath(['', '', '', '', '']);
  };

  const jsonKeysToList = (obj) => {
    if (!obj) return [];
    const keys = Object.keys(obj);
    return keys.sort();
  };

  const getJSONObjectAtPath = (obj, path) => {
    let current = obj;
    for (const key of path) {
      if (current && current.hasOwnProperty(key)) {
        current = current[key];
        if (typeof current !== 'object' || current === null) {
          return null;
        }
      } else {
        return null;
      }
    }
    return current;
  };

  const handleSpinnerChange = (index, selectedKey) => {
    const newPath = [...selectedPath];
    newPath[index] = selectedKey;
    setSelectedPath(newPath);

    const newSpinnerData = [...spinnerData];
    let currentObj = root;

    for (let i = 0; i <= index; i++) {
      if (newPath[i] && currentObj && currentObj.hasOwnProperty(newPath[i])) {
        currentObj = currentObj[newPath[i]];
      } else {
        currentObj = null;
        break;
      }
    }

    if (currentObj && index + 1 < spinnerData.length) {
      const nextKeys = jsonKeysToList(currentObj);
      newSpinnerData[index + 1] = nextKeys;
    } else if (index + 1 < spinnerData.length) {
      newSpinnerData[index + 1] = [];
    }

    setSpinnerData(newSpinnerData);
  };

  const handleInvertChange = (isChecked) => {
    setIsInverted(isChecked);
    if (!isChecked) {
      setIsOneStep(false);
    }
  };

  const handleOneStepChange = (isChecked) => {
    setIsOneStep(isChecked);
    const newSpinnerData = [...spinnerData];
    const newSelectedPath = [...selectedPath];

    if (isChecked) {
      // Set spinner[0] to "Forefist" and lock it
      newSelectedPath[0] = "Forefist";
      // Set spinner[1] to "Punch" and lock it
      newSelectedPath[1] = "Punch";
      setSelectedPath(newSelectedPath);

      // Load the next level for spinner[0] = "Forefist"
      if (root && root.hasOwnProperty("Forefist")) {
        const nextKeys = jsonKeysToList(root["Forefist"]);
        newSpinnerData[1] = nextKeys;

        // Load the next level for spinner[1] = "Punch"
        if (root["Forefist"] && root["Forefist"].hasOwnProperty("Punch")) {
          const nextKeys2 = jsonKeysToList(root["Forefist"]["Punch"]);
          newSpinnerData[2] = nextKeys2;
          // Load the next level for spinner[2]
          if (root["Forefist"]["Punch"]) {
            const nextKeys3 = jsonKeysToList(root["Forefist"]["Punch"]);
            newSpinnerData[3] = nextKeys3;
            // Load the next level for spinner[3]
            if (newSpinnerData[3].length > 0) {
              const nextKeys4 = jsonKeysToList(root["Forefist"]["Punch"][newSpinnerData[3][0]]);
              newSpinnerData[4] = nextKeys4;
            }
          }
        }
      }
      setSpinnerData(newSpinnerData);
    } else {
      // Reset spinner 1 and 2 if One Step is unticked
      newSelectedPath[0] = '';
      newSelectedPath[1] = '';
      setSelectedPath(newSelectedPath);

      // Reset spinner data for spinner 1 and 2
      if (root) {
        const rootKeys = Object.keys(root).sort();
        newSpinnerData[0] = rootKeys;
        newSpinnerData[1] = [];
        newSpinnerData[2] = [];
        newSpinnerData[3] = [];
        newSpinnerData[4] = [];
      }
      setSpinnerData(newSpinnerData);
    }
  };

  return (
    <div className="cascading-spinners-container">
      <h3>Blocking Tools</h3>
      <div style={{ marginBottom: '15px' }}>
        <label>
          <input
            type="checkbox"
            checked={isInverted}
            onChange={(e) => handleInvertChange(e.target.checked)}
          />
          Invert
        </label>
        {isInverted && (
          <div style={{ marginLeft: '20px', marginTop: '10px' }}>
            <label>
              <input
                type="checkbox"
                checked={isOneStep}
                onChange={(e) => handleOneStepChange(e.target.checked)}
              />
              One-Step
            </label>
          </div>
        )}
      </div>
      {spinnerData.map((keys, index) => (
        <div key={index} className="spinner-with-label">
          <span className="spinner-label">{spinnerLabels[index]}</span>
          <select
            value={selectedPath[index] || ''}
            onChange={(e) => handleSpinnerChange(index, e.target.value)}
            disabled={(index === 0 || index === 1) && isOneStep}
          >
            <option value="">Select...</option>
            {keys.map((key) => (
              <option key={key} value={key}>
                {key}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
};

// BodyParts component
const BodyParts = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>TKD Study - Body Parts</title>
      </Helmet>
      <div className="bodyParts-activity">
        <div className="bodyParts-container">
          <h1>Body Parts</h1>
          <div className="back-arrow" onClick={() => navigate('/')}>
            ← Back
          </div>
          <Section title="Body Parts" koreanTitle="Sinche Buwi">
            <div className="parts-grid">
              {bodyParts.map((part, i) => (
                <div className="part-card" key={i}>
                  <p>{part.label}<br /><b className="korean">{part.korean}</b></p>
                  <img src={part.image} alt={part.label} />
                </div>
              ))}
            </div>
            <div className="levels-image-block">
              <h3><big>Levels and Lines</big></h3>
              <img src={Levels} alt="Levels and Lines" />
            </div>
            <VitalPointsSpinner />
            <CascadingSpinners />
          </Section>
        </div>
      </div>
    </>
  );
};

export default BodyParts;
